import * as Yup from 'yup';
import { RegularExpression } from 'shared/constants/regular-expression';

export const LoginValidationSchema = () => {
    return Yup.object().shape({
        UserName: Yup.string()
            .required('Email is a required field.')
            .trim('Email is a required field.')
            .matches(RegularExpression.Email, 'Please enter a valid email.'),
        Password: Yup.string().required('Password is a required field.').trim('Password is a required field.'),
    });
};

export const SignUpValidationSchema = () => {
    return Yup.object().shape({
        firstName: Yup.string()
            .required('First Name is a required field.')
            .trim('First Name is a required field.')
            .matches(RegularExpression.Name, 'Please enter valid first name.'),
        lastName: Yup.string()
            .required('Last Name is a required field.')
            .trim('PLast Name is a required field.')
            .matches(RegularExpression.Name, 'Please enter valid last name.'),
        email: Yup.string()
            .required('Email is a required field.')
            .trim('Email is a required field.')
            .matches(RegularExpression.Email, 'Please enter a valid email.'),
        password: Yup.string()
            .required('Password is a required field.')
            .trim('Password is a required field.')
            .matches(
                RegularExpression.Password,
                'Password length must be between 8 to 16 chars and include lower and upper case letters, a number and one of this special chars: !#$%&-_@',
            ),
        mobileNo: Yup.string()
            .required('Mobile Phone is a required field.')
            .matches(/^\d+$/, 'Mobile number must contain only digits.')
            .min(6, 'Mobile number must be at least 6 digits.')
            .max(13, 'Mobile number cannot exceed 13 digits.'),
        isdCode: Yup.string().required('ISD Code is a required field.').trim('ISD Code is a required field.'),
        birthDate: Yup.date()
            .nullable()
            .min(new Date(1753, 0, 1), 'Please enter a valid date')
            .max(new Date(9999, 11, 31), 'Please enter a valid date')
            .test('is-valid-range', `BirthDate must be less than or equal to Current Date.`, function (value) {
                return !value || value <= new Date();
            })
            .typeError('Please enter a valid date')
            .required('Date of Birth is a required field.'),
        genderId: Yup.number().nullable().required('Gender is a required field.'),
        isAgreeToCommunication: Yup.boolean(),
        isAgreeToPrivacyPolicy: Yup.boolean().oneOf(
            [true],
            'Please read and accept the terms of Service and Privacy Policy',
        ),
        reCaptcha: Yup.string().nullable().required('Please fill up the captcha.').trim('Please fill up the captcha.'),
    });
};

export const ForgotPasswordValidationSchema = () => {
    return Yup.object().shape({
        email: Yup.string()
            .required('Email is a required field.')
            .trim('Email is a required field.')
            .matches(RegularExpression.Email, 'Please enter a valid email.'),
    });
};

export const ResetPasswordValidationSchema = () => {
    return Yup.object().shape({
        Password: Yup.string()
            .required('New Password is a required field.')
            .trim('New Password is a required field.')
            .matches(
                RegularExpression.Password,
                'New Password length must be between 8 to 16 chars and include lower and upper case letters, a number and one of this special chars: !#$%&-_@',
            ),
        ConfirmPassword: Yup.string()
            .required('Confirm New Password is a required field.')
            .trim('Confirm New Password is a required field.')
            .matches(
                RegularExpression.Password,
                'Confirm New Password length must be between 8 to 16 chars and include lower and upper case letters, a number and one of this special chars: !#$%&-_@',
            )
            .oneOf([Yup.ref('Password'), null], 'New Password and Confirm New Password must match.'),
        token: Yup.string(),
    });
};

export const ChangePasswordValidationSchema = () => {
    return Yup.object().shape({
        CurrentPassword: Yup.string()
            .required('Current Password is a required field.')
            .trim('Current Password is a required field.'),
        Password: Yup.string()
            .required('New Password is a required field.')
            .trim('New Password is a required field.')
            .matches(
                RegularExpression.Password,
                'New Password length must be between 8 to 16 chars and include lower and upper case letters, a number and one of this special chars: !#$%&-_@',
            ),
        ConfirmPassword: Yup.string()
            .required('Confirm New Password is a required field.')
            .trim('Confirm New Password is a required field.')
            .matches(
                RegularExpression.Password,
                'Confirm New Password length must be between 8 to 16 chars and include lower and upper case letters, a number and one of this special chars: !#$%&-_@',
            )
            .oneOf([Yup.ref('Password'), null], 'New Password and Confirm New Password must match.'),
        token: Yup.string(),
    });
};

export const VerifyOTPValidationSchema = () => {
    return Yup.object().shape({
        otp: Yup.string().nullable().required('OTP is a required field.').trim('OTP is a required field.'),
    });
};
